export default __webpack_public_path__ + "static/imgBackgroundMobile-e44f8343553614fd4c7d11a56853a289.png";